import { manageUpdateAccessObj } from "../../features/manageUpdateAccess/manageUpdateAccessTypes";
import { ChannelkartNetworkGetWithoutLob } from "../../services/networkService";
import { getAllConfiguartions } from "../../services/updateMetaConfigService";
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
import type {
  DomainNameToTypesMap,
  FormatNode,
  SupersetConfigItem,
} from "./editConfigurationTypes";
import { openPopup } from '../../stateManagement/actions/popupActions';
export const getConfiguration = async () => {
  try {
    const response = await getAllConfiguartions();
    return response;
  } catch {
    return [];
  }
};

export const getSupersetConfiguration = async (): Promise<
  SupersetConfigItem[]
> => {
  const env=localStorage.getItem("env")
   const API_BASE_URL=`https://${env}.salescode.ai/metadata`
    const DOMAIN_NAME="clientconfig"
  try {
    const response2 = await ChannelkartNetworkGetWithoutLob(`${API_BASE_URL}/${DOMAIN_NAME}`);
    const supersetFeature=response2?.data?.features.find((config:any)=>config.domainName==="clientconfig"&&config.domainType==="superset")
    const supersetConfiguration=supersetFeature?.domainValues?.[0]?.salescode_studio_config??[];
    const data= supersetConfiguration as SupersetConfigItem[];
    return data;
  } catch {
    return [];
  }
};

export const getDomainNameDomainTypeMap = (
  superset: SupersetConfigItem[],
): DomainNameToTypesMap => {
  const items = superset;
  const mapFromSuperset = getMap(items);
  return mapFromSuperset;
};
const getMap = (configList: any[]): DomainNameToTypesMap => {
  const map: DomainNameToTypesMap = {};
  for (const item of configList) {
    const name = String(item.domainName);
    const type = String(item.domainType);
    if (!map[name]) map[name] = [];
    if (!map[name].includes(type)) map[name].push(type);
  }
  return map;
};

export function parse(lobInfo: any = {}, supersetInfo: any) {
  return bruteForceParse(lobInfo, supersetInfo);
}
const safeSupportedValues = (supportedValues?: any) => {
  if (!supportedValues) {
    return [];
  }
  const arr = Array.isArray(supportedValues) ? supportedValues : [supportedValues];
  // make sure no empty string ( if type of supportedval[0] is string)
  return arr.filter((val: any) => {
    if(typeof val === "string"){
      return val !== "";
    }
    if(val == null || val == undefined){
      return false;
    }
    if(typeof val === "object"){
      return listEmptyKeysNested(val).length === 0;
    }
    if(Array.isArray(val)){
      return listEmptyKeysFlat(val).length === 0;
    }
    return true;
  });
}
// helpers to report which keys have empty supported values
const formatEmptyKeysError = (keys: string[]) =>
  `In SUPERSET_INFO , supported values are empty for keys [${keys.join(", ")}]`;
const listEmptyKeysFlat = (obj: Record<string, any>): string[] => {
  if(!obj || typeof obj !== "object") return [];
  return Object.entries(obj)
    .filter(([_, v]) => safeSupportedValues(Array.isArray(v) ? v : [v]).length === 0)
    .map(([k]) => k);
};
const listEmptyKeysNested = (obj: Record<string, any>, prefix = ""): string[] => {
  if(!obj || typeof obj !== "object") return [];
  const keys: string[] = [];
  for (const key of Object.keys(obj)) {
    const val = obj[key];
    const pathKey = prefix ? `${prefix}.${key}` : key;
    if (Array.isArray(val)) {
      if (safeSupportedValues(val).length === 0) keys.push(pathKey);
    } else if (val && typeof val === "object") {
      keys.push(...listEmptyKeysNested(val, pathKey));
    } else {
      if (safeSupportedValues([val]).length === 0) keys.push(pathKey);
    }
  }
  return keys;
};
// sorting helper: numeric-aware (treat "2" like 2), otherwise case-insensitive lexicographic
const sortEnum = <T = any>(values: T[]): T[] => {
  const toMeta = (v: any) => {
    const s = String(v).trim();
    const num = Number(s);
    const numericPattern = /^-?\d+(\.\d+)?$/;
    const isNumeric = (typeof v === "number" && Number.isFinite(v)) || (numericPattern.test(s) && Number.isFinite(num));
    return {
      isNumeric,
      numValue: isNumeric ? (typeof v === "number" ? v : num) : Number.NaN,
      strValue: s.toLowerCase(),
      raw: v,
    };
  };
  const arr = [...values];
  arr.sort((a: any, b: any) => {
    const A = toMeta(a);
    const B = toMeta(b);
    if (A.isNumeric && B.isNumeric) {
      return A.numValue - B.numValue;
    }
    if (A.isNumeric && !B.isNumeric) return -1;
    if (!A.isNumeric && B.isNumeric) return 1;
    return A.strValue.localeCompare(B.strValue, undefined, { sensitivity: "base", numeric: true });
  });
  return arr;
};
export function bruteForceParse(lobInfo: any = {}, supersetInfo: any) {
  const format = supersetInfo.format;
  let schema = {},
    ui = {},
    parsedValue = {},
    data = {};
    const cleanFormat = format.replace(/\s+/g, "");
  switch (cleanFormat) {
    case "array[]": {
      /*
        {
          "type": "array",
          "children": [
            {
             "type": "primitive",
             "dataType": typeof supersetInfo.supportedValues.[0] ?? "string"
             "possibleValues": supersetInfo.supportedValues
            }
          ]
          }
          */
         const supportedValues = safeSupportedValues(supersetInfo.supportedValues);
      // if supported values are empty, just render without throwing
      schema = {
        type: "array",
        title: supersetInfo.domainType ?? "Items",
        items: {
          type: "string",
          enum: sortEnum(supportedValues),
        },
      };
      ui = {
        type: "Control",
        scope: "#",
        options: {
          elementLabelProp: "value",
          showSortButtons: true,
          addButtonLabel: "Add item",
          removeButtonLabel: "Remove",
          spacing: "2em"
        },
      };
      data = lobInfo?.domainValues ?? [];
      // parsedValue = {
      //   type: "array",
      //   pathToNode: "./",
      //   children: [
      //     {
      //       type: "primitive",
      //       dataType:
      //         supportedValues.length > 0 ? typeof supportedValues[0] : "string",
      //       possibleValues: supportedValues,
      //       pathToNode: "./array[i]",
      //     },
      //   ],
      // };

      break;
    }
    case "array[json{}]": {
      const supportedValues = supersetInfo.supportedValues || {};
      // if no supported values for any key, omit them silently
      // JSON Forms schema
      schema = {
        type: "array",
        title: supersetInfo.domainType ?? "Items",
        items: {
          type: "object",
          title: supersetInfo.domainType ?? "Items",
          properties: Object.fromEntries(
            Object.entries(supportedValues).flatMap(([key, values]) => {
              const supportedVals = safeSupportedValues(values as any[]);
              if (supportedVals.length === 0) return [];
              const typeIs = typeof supportedVals[0];
              return [
                [key, { type: typeIs, enum: sortEnum(supportedVals) }],
              ];
            })
          ),
        },
      };

      // JSON Forms UI schema
      // build UI elements only for keys that have non-empty supported values
      const uiKeys = Object.entries(supportedValues)
        .filter(([_, values]) => safeSupportedValues(values as any[]).length > 0)
        .map(([k]) => k);
      ui = {
        type: "VerticalLayout",
        scope: "#",
        options: {
          showSortButtons: true,
          addButtonLabel: "Add item",
          removeButtonLabel: "Remove",
          spacing: "2em"
        },
        // Each array item (object) layout
        elements: uiKeys.map((key) => ({
          type: "Control",
          scope: `#/items/properties/${key}`,
          label: key,
        })),
      };

      // Form initial data
      data = lobInfo?.domainValues ?? [];

      // Parsed format metadata
      // parsedValue = {
      //   type: "array",
      //   pathToNode: "./",
      //   children: [
      //     {
      //       type: "json",
      //       pathToNode: "./array[i]",
      //       children: Object.keys(supportedValues).map((key) => ({
      //         type: "primitive",
      //         key,
      //         dataType:
      //           supportedValues[key]?.length > 0
      //             ? typeof supportedValues[key][0]
      //             : "string",
      //         possibleValues: supportedValues[key],
      //         selectedValue: selectedValues?.[0]?.[key] ?? null,
      //         pathToNode: `./array[i]/${key}`,
      //       })),
      //     },
      //   ],
      // };
      break;
    }
    case "array[json{json{}}]":
    case "array[json{json{}}json{}]": {
      const supportedValues = supersetInfo.supportedValues || {};
      const selectedValues = lobInfo?.domainValues ?? [];
      // omit empty-supported keys silently
      // Recursive function to generate schema for nested objects
      const buildSchema = (obj: any): any => {
        const schema: any = { type: "object", properties: {} };
        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (Array.isArray(val)) {
            // Leaf primitive array → string enum
            const safeSupportedValuesForArray = safeSupportedValues(val);
            if (safeSupportedValuesForArray.length > 0) {
              schema.properties[key] = {
                type: typeof safeSupportedValuesForArray[0],
                enum: sortEnum(safeSupportedValuesForArray),
              };
            }
          } else if (val && typeof val === "object") {
            // Nested object → recurse and include only if it has non-empty properties
            const child = buildSchema(val);
            if (child && Object.keys(child.properties || {}).length > 0) {
              schema.properties[key] = child;
            }
          }
        }
        return schema;
      };

      schema = {
        type: "array",
        title: supersetInfo.domainType ?? "Items",
        items: buildSchema(supportedValues),
      };

      // Recursive function to build uischema for JSON Forms
      const buildUi = (obj: any, scopePrefix: string): any[] => {
        const elements: any[] = [];
        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (Array.isArray(val)) {
            if (safeSupportedValues(val).length > 0) {
              elements.push({
                type: "Control",
                label: key,
                scope: `${scopePrefix}/properties/${key}`,
                options: { spacing: "2em" }
              });
            }
          } else if (typeof val === "object") {
            elements.push(...buildUi(val, `${scopePrefix}/properties/${key}`));
          }
        }
        return elements;
      };

      ui = {
        type: "Control",
        scope: "#",
        options: { showSortButtons: true, spacing: "2em" },
        elements: buildUi(supportedValues, "#/items"),
      };

      data = selectedValues;

      // Optional: parsedValue metadata
      const buildParsedValue = (obj: any, path: string): FormatNode[] => {
        const children: FormatNode[] = [];
        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (Array.isArray(val)) {
            const safeVals = safeSupportedValues(val);
            if (safeVals.length > 0) {
              children.push({
                type: "primitive",
                key,
                dataType: typeof safeVals[0],
                possibleValues: sortEnum(safeVals),
                // selectedValue: selectedValues?.[0]?.[key] ?? null,
                pathToNode: `${path}/${key}`,
              });
            }
          } else if (typeof val === "object") {
            children.push({
              type: "json",
              pathToNode: `${path}/${key}`,
              children: buildParsedValue(val, `${path}/${key}`),
            });
          }
        }
        return children;
      };

      parsedValue = {
        type: "array",
        pathToNode: "./",
        children: [
          {
            type: "json",
            pathToNode: "./array[i]",
            children: buildParsedValue(supportedValues, "./array[i]"),
          },
        ],
      };

      break;
    }
    case "array[json{array[]}]":
    case "array[json{array[]}json{}]":
    case "array[json{}json{array[]}]": {
      const supportedValuesArrays = supersetInfo["supportedValues-ARRAY"] || {};
      const supportedValuesJSON = supersetInfo["supportedValues-JSON"] || {};

      // if both -array and -json have a common key then throw error 
      uniqueKeysBetweenArraysAndJSON(supportedValuesArrays, supportedValuesJSON);
      const selectedValues = lobInfo?.domainValues ?? [];
      // omit empty-supported keys silently
      /** --------------------------------------------
       * ✅ SCHEMA BUILDER
       * -------------------------------------------- */
      const buildSchema = (
        arraysObj: Record<string, any>,
        jsonObj: Record<string, any>
      ): any => {
        const schema: any = { type: "object", properties: {} };

        // Array-type keys → array of possible values
        for (const key of Object.keys(arraysObj)) {
          const val = arraysObj[key];
          const safeVals = safeSupportedValues(val);
          if (safeVals.length > 0) {
            schema.properties[key] = {
              type: "array",
               
              items: {
                type: typeof safeVals[0],
                enum: sortEnum(safeVals),
              },
            };
          }
        }

        // JSON-type keys → single primitive field
        for (const key of Object.keys(jsonObj)) {
          const val = jsonObj[key];
          const safeVals = safeSupportedValues(val);
          if (safeVals.length > 0) {
            schema.properties[key] = {
              type: typeof safeVals[0],
              enum: sortEnum(safeVals),
            };
          }
        }

        return schema;
      };

      schema = {
        type: "array",
        title: supersetInfo.domainType ?? "Items",
        items: buildSchema(supportedValuesArrays, supportedValuesJSON),
      };

      /** --------------------------------------------
       * ✅ UI SCHEMA BUILDER
       * -------------------------------------------- */
      const buildUi = (
        arraysObj: Record<string, any>,
        jsonObj: Record<string, any>,
        scopePrefix: string
      ): any[] => {
        const elements: any[] = [];

        // Single-value fields
        for (const key of Object.keys(jsonObj)) {
          const safeVals = safeSupportedValues(jsonObj[key]);
          if (safeVals.length > 0) {
            elements.push({
              type: "Control",
              label: key,
              scope: `${scopePrefix}/properties/${key}`,
              options: { spacing: "2em" }
            });
          }
        }

        // Multi-value array fields
        for (const key of Object.keys(arraysObj)) {
          const safeVals = safeSupportedValues(arraysObj[key]);
          if (safeVals.length > 0) {
            elements.push({
              type: "Control",
              label: key,
              scope: `${scopePrefix}/properties/${key}`,
              options: { showSortButtons: true , spacing: "2em" },
            });
          }
        }

        return elements;
      };

      ui = {
        type: "Control",
        scope: "#",
        options: { showSortButtons: true , spacing: "2em" },
        elements: buildUi(
          supportedValuesArrays,
          supportedValuesJSON,
          "#/items"
        ),
      };

      data = selectedValues;

      /** --------------------------------------------
       * ✅ PARSED VALUE BUILDER
       * -------------------------------------------- */
      const buildParsedValue = (
        arraysObj: Record<string, any>,
        jsonObj: Record<string, any>,
        path: string
      ): FormatNode[] => {
        const children: FormatNode[] = [];

        // Array fields
        for (const key of Object.keys(arraysObj)) {
          const val = arraysObj[key];
          const safeVals = safeSupportedValues(val);
          if (safeVals.length > 0) {
            children.push({
              type: "array",
              pathToNode: `${path}/${key}`,
              children: [
                {
                  type: "primitive",
                  dataType: typeof safeVals[0],
                  possibleValues: sortEnum(safeVals),
                  pathToNode: `${path}/${key}/[i]`,
                },
              ],
            });
          }
        }

        // JSON fields
        for (const key of Object.keys(jsonObj)) {
          const val = jsonObj[key];
          const safeVals = safeSupportedValues(val);
          if (safeVals.length > 0) {
            children.push({
              type: "primitive",
              dataType: typeof safeVals[0],
              possibleValues: sortEnum(safeVals),
              pathToNode: `${path}/${key}`,
            });
          }
        }

        return children;
      };

      parsedValue = {
        type: "array",
        pathToNode: "./",
        children: [
          {
            type: "json",
            pathToNode: "./array[i]",
            children: buildParsedValue(
              supportedValuesArrays,
              supportedValuesJSON,
              "./array[i]"
            ),
          },
        ],
      };

      break;
    }
    // TODO : this is not working properly , clientconfig > error_logger_congiruation 
    case "array[json{array[]json{}}]":
    case "array[json{array[]}json{json{}}]": 
    {
      // Get supported values
      const supportedValuesArrays = supersetInfo["supportedValues-ARRAY"] || {};
      const supportedValuesJSON = supersetInfo["supportedValues-JSON"] || {};
      uniqueKeysBetweenArraysAndJSON(supportedValuesArrays, supportedValuesJSON);
      const selectedValues = lobInfo?.domainValues ?? [];
      // omit empty-supported keys silently
      // --- Helper: Build schema recursively ---
      const buildSchema = (
        arrays: Record<string, any[]>,
        jsons: Record<string, any>
      ): any => {
        const schema: any = { type: "object", properties: {} };

        // Arrays first
        for (const key of Object.keys(arrays)) {
          const values = arrays[key];
          const safeVals = safeSupportedValues(values as any[]);
          if (safeVals.length > 0) {
            schema.properties[key] = {
              type: "array",
               
              items: {
                type: typeof safeVals[0],
                enum: sortEnum(safeVals),
              },
            };
          }
        }

        // JSON objects
        for (const key of Object.keys(jsons)) {
          const val = jsons[key];
          if (Array.isArray(val)) {
            const safeVals = safeSupportedValues(val as any[]);
            if (safeVals.length > 0) {
              schema.properties[key] = {
                type: "array",
                 
                items: { type: "string", enum: sortEnum(safeVals) },
              };
            }
          } else if (val && typeof val === "object") {
            // Nested object → recurse and include only if it has non-empty properties
            const child = buildSchema({}, val);
            if (child && Object.keys(child.properties || {}).length > 0) {
              schema.properties[key] = child;
            }
          } else {
            const safeVals = safeSupportedValues([val] as any[]);
            if (safeVals.length > 0) {
              schema.properties[key] = { type: typeof safeVals[0], enum: sortEnum(safeVals) };
            }
          }
        }

        return schema;
      };

      // Build the final schema
      schema = {
        type: "array",
        title: supersetInfo.domainType ?? "Items",
        items: buildSchema(supportedValuesArrays, supportedValuesJSON),
      };

      // --- Helper: Build UI schema recursively ---
      const buildUi = (
        arrays: Record<string, any[]>,
        jsons: Record<string, any>,
        scopePrefix: string
      ): any[] => {
        const elements: any[] = [];

        for (const key of Object.keys(arrays)) {
          elements.push({
            type: "Control",
            label: key,
            scope: `${scopePrefix}/properties/${key}`,
            options: { spacing: "2em" }
          });
        }

        for (const key of Object.keys(jsons)) {
          const val = jsons[key];
          if (Array.isArray(val)) {
            elements.push({
              type: "Control",
              label: key,
              scope: `${scopePrefix}/properties/${key}`,
              options: { spacing: "2em" }
            });
          } else if (typeof val === "object") {
            elements.push(
              ...buildUi({}, val, `${scopePrefix}/properties/${key}`)
            );
          } else {
            elements.push({
              type: "Control",
              label: key,
              scope: `${scopePrefix}/properties/${key}`,
              options: { spacing: "2em" }
            });
          }
        }

        return elements;
      };

      // Build UI
      ui = {
        type: "Control",
        scope: "#",
        options: { showSortButtons: true , spacing: "2em" },
        elements: buildUi(
          supportedValuesArrays,
          supportedValuesJSON,
          "#/items"
        ),
      };

      // Data
      data = selectedValues;

      // --- Helper: Build parsed value metadata ---
      const buildParsedValue = (
        arrays: Record<string, any[]>,
        jsons: Record<string, any>,
        path: string
      ): FormatNode[] => {
        const children: FormatNode[] = [];

        for (const key of Object.keys(arrays)) {
          const val = arrays[key];
          children.push({
            type: "primitive",
            key,
            dataType: val.length > 0 ? typeof val[0] : "string",
            possibleValues: val.sort(),
            pathToNode: `${path}/${key}`,
          });
        }

        for (const key of Object.keys(jsons)) {
          const val = jsons[key];
          if (Array.isArray(val)) {
            children.push({
              type: "primitive",
              key,
              dataType: val.length > 0 ? typeof val[0] : "string",
              possibleValues: val.sort(),
              pathToNode: `${path}/${key}`,
            });
          } else if (typeof val === "object") {
            children.push({
              type: "json",
              pathToNode: `${path}/${key}`,
              children: buildParsedValue({}, val, `${path}/${key}`),
            });
          }
        }

        return children;
      };

      // Parsed value
      parsedValue = {
        type: "array",
        pathToNode: "./",
        children: [
          {
            type: "json",
            pathToNode: "./array[i]",
            children: buildParsedValue(
              supportedValuesArrays,
              supportedValuesJSON,
              "./array[i]"
            ),
          },
        ],
      };
      break;
    }
  }
  return {
    schema,
    ui,
    parsedValue,
    data,
  };
}

const uniqueKeysBetweenArraysAndJSON = (arrays: Record<string, any[]>, json: Record<string, any[]>) => {
  const arrayKeys = Object.keys(arrays);
  const jsonKeys = Object.keys(json);
  const commonKeys = arrayKeys.filter(key => jsonKeys.includes(key));
  if(commonKeys.length > 0){
    throw new Error(`In Superset configuration , Arrays and JSON type values have common keys: ${commonKeys.join(", ")}`);
  }
}
const getLOB = () => {
  return  JSON.parse(localStorage.authContext).user.lob;
}
export const sendUpdateRequest = async (
  domainName: string,
  domainType: string,
  domainValues: any,
  successCallback: () => void
) => {
  try {
    const requestBody = {
      lob:getLOB(),
      domainName: domainName,
      domainType: domainType,
      domainValues: JSON.parse(JSON.stringify(domainValues)),
    };
    const api = `/metadata/${domainName}?name=${domainType}`;
    const apiType = "PUT";
    validateWithOtp(
      (verifiedUser?: manageUpdateAccessObj, verifyResponse?: any) => {
        try {
          if (verifyResponse.status === 201 || verifyResponse.status === 200) {
            successCallback();
            openPopup("Success","Your information has been updated!");
          } else if (verifyResponse.status === 204) {
          } else {
            throw new Error();
          }
        } catch (error) {
          openPopup("Error","Something went wrong!" + error);
        }
      },
      ["uat", "demo", "prod", "prod-egtm"],
      "admin",
      api,
      requestBody,
      apiType
    );
  } catch (error) {
    alert("Something went wrong!");
  }
};

export const createNewConfig = async ( domainName: string,
  domainType: string,
  domainValues: any,
  successCallback: () => void) => {
    try {
      const api = "/metadata";
      const apiType = "POST";
      let parsedJsonValue = JSON.parse(JSON.stringify(domainValues));

      const requestBody = {
        lob: getLOB(),
        domainName: domainName,
        domainType: domainType,
        domainValues: parsedJsonValue,
      };

      const requestArray: any[] = [];
      requestArray.push(requestBody);
      validateWithOtp((verifiedUser?: manageUpdateAccessObj,verifyResponse?: any) => {
        try{
          if (verifyResponse.status === 201 || verifyResponse.status === 200) {
            successCallback();
            openPopup("Success","Your information has been updated!");
          } else {
            throw new Error();
          }
        }catch(error){
          openPopup("Error","Something went wrong!" + error);
        }
      },undefined,"admin",api,requestArray,apiType);

    } catch (error) {
      openPopup("Error","Something went wrong!" + error);
    }
  };
export { SupersetConfigItem };
